/* globals $ */
import { registerClass } from 'libs/ComponentLoader'

import './styles.scss'

class Button {
  constructor (element) {
    this.$el = $(element)
  }
}

registerClass('Button', Button)
